import React, { useMemo, useState } from 'react';
import { View, Image, Text } from 'react-native';
import { useCurrency, useTranslation } from '@oolio-group/localization';
import { UpsellProduct } from '@oolio-group/domain';
import { makeStyles } from './ProductCard.styles';
import { useTheme } from '../../../hooks/useTheme';
import { getInitials } from '@oolio-group/client-utils';

const ProductCard = ({ product }: { product: UpsellProduct }) => {
  const { formatCurrency } = useCurrency();
  const [imageError, setImageError] = useState(false);
  const { translate } = useTranslation();
  const { colors } = useTheme();
  const styles = useMemo(() => makeStyles(colors), [colors]);
  const { name, description, price, imageUrl, savingValue } = product;

  return (
    <View style={styles.card}>
      {savingValue !== undefined && savingValue > 0 && (
        <View style={styles.badge}>
          <Text style={styles.badgeText}>
            {translate('modal.savingValues', {
              amount: formatCurrency(savingValue),
            })}
          </Text>
        </View>
      )}
      <View style={styles.imageContainer}>
        {imageUrl && !imageError ? (
          <Image
            source={{ uri: imageUrl }}
            style={styles.image}
            resizeMode="cover"
            onError={() => setImageError(true)}
          />
        ) : (
          <View style={styles.imagePlaceholder}>
            <Text style={styles.placeholderText}>{getInitials(name)}</Text>
          </View>
        )}
      </View>
      <View style={styles.details}>
        <Text style={styles.name} numberOfLines={2}>
          {name}
        </Text>
        <Text style={styles.description} numberOfLines={2}>
          {description}
        </Text>
        <Text style={styles.price}>
          {price ? formatCurrency(price) : 'N/A'}
        </Text>
      </View>
    </View>
  );
};

export default ProductCard;
